import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AppService } from './app.service';
import { BusService } from './Bus.service';
import { faArrowRightFromBracket, faGaugeHigh, faGaugeSimpleHigh, faPerson } from '@fortawesome/free-solid-svg-icons';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';


type ProfileType = {
  givenName?: string,
  surname?: string,
  userPrincipalName?: string,
  id?: string
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Attendance Meter Detail';
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  profile: ProfileType = {};
  User:any={};
  selected:any;

  faArrowRightFromBracket = faArrowRightFromBracket;
  faGaugeHigh=faGaugeHigh;
  faGaugeSimpleHigh = faGaugeSimpleHigh;
  faPerson=faPerson;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private http: HttpClient,
		private srv: AppService,
    private comm: BusService
  ) {}

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.comm.setLoc({lId:0,description:''});
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if (this.loginDisplay) {
      this.GetProfile();
		}

  }
  GetProfile(){
    this.http.get(GRAPH_ENDPOINT)
      .subscribe(profile => {
        this.profile = profile;
        this.GetUser();
      });

  }
  GetUser(){
 //   this.profile.userPrincipalName = 'acadena4@yisd.net'
    this.srv.GetUser(this.profile.userPrincipalName).subscribe((res:any)=>{
      this.User = res;
      this.selected = this.User.lstLocations[0];
      this.comm.setEmployee(this.User);
      this.comm.setLoc(this.selected);

      if(this.User.lstLocations.length == 0)
      {


      }
      
    })

  }
  onLocSelected(sel:any){
    this.comm.setLoc(this.selected);


  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService.loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/"
      });
    } else {
      this.authService.logoutRedirect({
        postLogoutRedirectUri: "/",
      });
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
